import { Badge } from "react-bootstrap";
import styled from "styled-components";
import { EstadisticasNumericas } from "../../hooks/estadisticasNumericas";

interface EstadisticasBadgesProps {
  estadisticas: EstadisticasNumericas | null;
  formatearValor: (valor: number) => string;
}

function EstadisticasBadges({
  estadisticas,
  formatearValor,
}: EstadisticasBadgesProps) {
  if (!estadisticas) {
    return null;
  }

  return (
    <BadgesRow>
      <Badge pill bg="info">
        Promedio: {formatearValor(estadisticas.promedio)}
      </Badge>
      <Badge pill bg="danger">
        Mínimo: {formatearValor(estadisticas.minimo)}
      </Badge>
      <Badge pill bg="success">
        Máximo: {formatearValor(estadisticas.maximo)}
      </Badge>
    </BadgesRow>
  );
}

const BadgesRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export default EstadisticasBadges;
